import { MdDelete } from "react-icons/md";

export function InvoiceRowSummary({ currency, total, isFirstIndex, removeRow }) {
    return (
        <>
            {
                isFirstIndex ?
                    <div className='h-full p-2 outline-none border-none bg-slate-100 text-sm text-gray-500 flex items-center'>
                        {currency}{total}
                    </div>
                    :
                    <div className='grid grid-cols-3 h-full'>
                        <div className='col-span-2 p-2 outline-none border-none bg-slate-100 text-sm text-gray-500 flex items-center'>
                            {currency}{total}
                        </div>
                        <div onClick={removeRow} className="col-span-1 bg-slate-100 hover:bg-slate-200 cursor-pointer flex items-center justify-center border-l text-lg">
                            <MdDelete className="text-gray-500" />
                        </div>
                    </div>
            }
        </>
    )
}